
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoashtavinayakdarshaninnova() {



    const cardData =
    {
        keyword: 'Pune to Ashtavinayak Darshan Innova Crysta Booking',
        heading: 'Meghana Cab : Pune to Ashtavinayak Darshan Innova Crysta Booking',
        headingDescription: 'Meghana Cab offers Pune to Ashtavinayak Darshan Innova Crysta Booking, providing a premium, spacious, and spiritually enriching travel experience for pilgrims visiting the renowned eight Ganesha temples around Pune. Covering approximately 650–850 km over a well-planned 2-day circuit—including sacred sites like Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon—our Innova Crysta ensures comfort with plush leather interiors, ample legroom, air-conditioning, and generous luggage space . Our service includes door‑to‑door pickup from any location in Pune, experienced chauffeurs familiar with the ghat and temple routes, GPS-enabled vehicles, flexible booking options (one‑way, round‑trip, or hourly), and 24/7 customer support. Book your Pune to Ashtavinayak Darshan Innova Crysta with Meghana Cab for a serene, luxurious, and fully supported pilgrimage journey—tailored for devotion, comfort, and spiritual discovery.',


        top: 'Top Places to Visit in Ashtavinayak with Meghana Cab',

"topPlaces": [
  {
    "title": "Mayureshwar Temple, Morgaon",
    "description": "Considered the most important of the eight temples, the Mayureshwar temple in Morgaon is where every Ashtavinayak yatra begins and ends. Surrounded by high walls and four majestic gates symbolizing the four yugas, the temple features a distinct idol of Lord Ganesha riding a peacock. It has deep spiritual significance as it marks the site where Ganesha defeated the demon Sindhura. The temple's Peshwa-era architecture and the presence of the sacred Nandi bull make it a unique place of worship."
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "Located on the banks of the Bhima River in Siddhatek, this temple houses a rare right-trunked Ganesha idol, believed to be extremely powerful in granting wishes. Surrounded by natural beauty and serenity, the temple is associated with Lord Vishnu, who worshipped Ganesha here before battling demons. Pilgrims often perform a pradakshina (circumambulation) around the hill on which the temple stands."
  },
  {
    "title": "Ballaleshwar Temple, Pali",
    "description": "The only Ashtavinayak temple named after a devotee—Ballal—this temple in Pali features a Ganesha idol sitting on a stone throne with diamonds embedded in its eyes and navel. The temple’s east-facing design ensures that the morning sun illuminates the deity. It is one of the few temples where Ganesha is worshipped with a name tied to a devotee’s unshakable faith and devotion."
  },
  {
    "title": "Varadvinayak Temple, Mahad",
    "description": "Located in Mahad near Khopoli, the Varadvinayak temple is unique as devotees are allowed to enter the sanctum and directly offer prayers to the idol. This self-manifested (swayambhu) idol was discovered in a nearby lake. The temple complex includes a beautiful pond, resting halls, and stone inscriptions, and it is known for its tranquil, forested surroundings."
  },
  {
    "title": "Chintamani Temple, Theur",
    "description": "Situated near Pune, the Chintamani temple at Theur is associated with the legend of Ganesha retrieving a precious jewel from a greedy demon for the sage Kapila. The temple’s structure reflects Peshwa-era design, and the idol here is calm and meditative. The temple is considered especially powerful for removing anxiety and mental stress (chinta)."
  },
  {
    "title": "Girijatmaj Temple, Lenyadri",
    "description": "This temple is unique as it is located inside a rock-cut cave in the Lenyadri Hills, part of a group of 18 Buddhist caves. The Girijatmaj form of Ganesha here is worshipped as the son of Goddess Parvati. Reached by climbing around 300 steps, the temple offers stunning views of the surrounding valleys and is revered for its serene and meditative environment."
  },
  {
    "title": "Vighnahar Temple, Ozar",
    "description": "Located on the banks of the Kukadi River, this temple in Ozar commemorates Ganesha’s victory over the demon Vighnasura. The east-facing idol has a striking tilak on its forehead and is adorned with emeralds and rubies. The temple’s spacious courtyard, sculpted entrance, and golden pinnacle are notable features, making it a major stop for devotees."
  },
  {
    "title": "Mahaganapati Temple, Ranjangaon",
    "description": "The final temple in the pilgrimage, Mahaganapati of Ranjangaon is said to represent Ganesha in his most powerful form. The idol, which is larger than life, is said to be hidden in a basement chamber and only partially visible in the sanctum. The temple is associated with Ganesha aiding Shiva in defeating the demon Tripurasura, and is built in a beautifully symmetrical style by Peshwa rulers."
  }
],

   "services": [
    {
      "name": "Pune to Ashtavinayak Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune for your spiritual journey to all eight Ashtavinayak Ganpati temples in Maharashtra. Enjoy a serene, air-conditioned ride with a professional chauffeur across this sacred pilgrimage circuit."
    },
    {
      "name": "One Way Innova Crysta Pune Ashtavinayak",
      "description": "Choose a one-way Innova Crysta taxi if you're starting your Ashtavinayak pilgrimage from Pune and plan to return via another route. Flexible, convenient, and cost-effective."
    },
    {
      "name": "Round Trip Innova Crysta Pune Ashtavinayak",
      "description": "Opt for a round trip cab from Pune covering all Ashtavinayak temples. Our package includes complete pickup and drop service, same cab for the entire journey, and relaxed travel timings."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Ashtavinayak",
      "description": "Travel comfortably in a fully air-conditioned Innova Crysta to beat the heat while visiting the eight revered Ganpati shrines scattered across Maharashtra."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Ashtavinayak",
      "description": "Our experienced chauffeurs ensure a smooth and spiritually focused journey across all Ashtavinayak temples. Expect safe driving and route familiarity for a seamless travel experience."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Ashtavinayak",
      "description": "Enjoy the comfort of a private cab for your group or family. Travel at your own pace, with no sharing, and explore each temple with complete peace of mind."
    },
    {
      "name": "Online Booking Innova Crysta Pune Ashtavinayak",
      "description": "Book your Ashtavinayak cab online from Pune with real-time availability, instant confirmation, and competitive pricing. Avoid last-minute hassles and plan your pilgrimage stress-free."
    },
    {
      "name": "Ashtavinayak Pilgrimage Innova Crysta",
      "description": "Embark on the sacred Ashtavinayak Yatra with our special Innova Crysta package. Visit all eight temples in a well-planned route while enjoying superior comfort and reliable service."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Ashtavinayak",
      "description": "Our Innova Crysta cabs feature plush seating, ample legroom, and smooth suspension—perfect for long-distance travel and multi-stop temple visits like the Ashtavinayak Darshan."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Ashtavinayak",
      "description": "Pilgrimage doesn’t have to be expensive. Choose our budget Innova Crysta taxi for a spiritual yet affordable trip from Pune to all eight Ganpati temples."
    },
    {
      "name": "Religious Tour Innova Crysta Pune",
      "description": "Plan a complete religious tour with Innova Crysta rentals tailored for spiritual routes including Ashtavinayak, Bhimashankar, and other shrines near Pune and Maharashtra."
    },
    {
      "name": "Family Trip Innova Crysta Ashtavinayak",
      "description": "Our spacious 6-7 seater Innova Crysta cabs are ideal for family trips to the Ashtavinayak temples. Enjoy comfort, safety, and convenience throughout the entire pilgrimage."
    },
    {
      "name": "Reliable Innova Crysta Taxi Ashtavinayak",
      "description": "Count on our punctual service, courteous chauffeurs, and well-maintained Innova Crysta cabs for your Ashtavinayak tour. We prioritize timely arrivals and smooth travel experiences."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Our Innova Crysta vehicles are built for long-distance, multi-destination tours like Ashtavinayak. Drive worry-free with premium interiors and top mechanical performance."
    },
    {
      "name": "Weekend Trip Innova Crysta Ashtavinayak",
      "description": "Perfect for a weekend spiritual getaway from Pune, our Ashtavinayak cab package covers all temples with comfort, timely service, and ample sightseeing time."
    }
  ],
  "tableData": [
    ["Pune to Ashtavinayak Innova Crysta Cab Booking", "One Way Innova Crysta Pune Ashtavinayak"],
    ["Round Trip Innova Crysta Pune Ashtavinayak", "AC Innova Crysta Taxi Pune Ashtavinayak"],
    ["Chauffeur Driven Innova Crysta Pune Ashtavinayak", "Private Innova Crysta Taxi Pune Ashtavinayak"],
    ["Online Booking Innova Crysta Pune Ashtavinayak", "Ashtavinayak Pilgrimage Innova Crysta"],
    ["Comfortable Innova Crysta Cab Pune Ashtavinayak", "Budget Innova Crysta Taxi Pune Ashtavinayak"],
    ["Religious Tour Innova Crysta Pune", "Family Trip Innova Crysta Ashtavinayak"],
    ["Reliable Innova Crysta Taxi Ashtavinayak", "Long Distance Innova Crysta Taxi"],
    ["Weekend Trip Innova Crysta Ashtavinayak", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Booking for Pune to Ashtavinayak Darshan",
    "WhyChoosedescription": "Embark on a sacred journey to the eight revered Ganesh temples of Maharashtra with our comfortable and spacious Innova Crysta. Starting from Pune, our Ashtavinayak Darshan package ensures a divine and hassle-free pilgrimage experience."
  },
  {
    "WhyChooseheading": "Spacious and Ideal for Group Pilgrimage Travel",
    "WhyChoosedescription": "Our Innova Crysta vehicles comfortably seat up to 6–7 passengers, making them perfect for family pilgrimages or group darshan trips. With ample legroom and luggage space, enjoy your journey across the Ashtavinayak circuit without any discomfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Temple Route Knowledge",
    "WhyChoosedescription": "Our chauffeurs are familiar with the entire Ashtavinayak route, temple timings, parking spots, and darshan procedures. Their guidance ensures you visit all 8 temples—Mayureshwar, Siddhatek, Ballaleshwar, Varadvinayak, Chintamani, Girijatmaj, Vighnahar, and Mahaganapati—smoothly and on time."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Each Innova Crysta is thoroughly cleaned and sanitized before every trip. We prioritize cleanliness, safety, and reliability so that your spiritual journey remains peaceful and uninterrupted."
  },
  {
    "WhyChooseheading": "Flexible Itineraries – One-Day, Two-Day or Custom Plans",
    "WhyChoosedescription": "Choose from a fast one-day darshan, a relaxed two-day itinerary with overnight stay, or a fully customized plan based on your group’s needs and pace. We tailor the travel to suit elders, children, or special requests."
  },
  {
    "WhyChooseheading": "Transparent Pricing with All-Inclusive Packages",
    "WhyChoosedescription": "Our Ashtavinayak tour rates cover fuel, tolls, parking, driver allowance, and taxes. You get full clarity with no hidden charges—so you can focus on your prayers, not the bill."
  },
  {
    "WhyChooseheading": "Ideal for Spiritual Seekers, Families, and Elderly Travelers",
    "WhyChoosedescription": "Our Innova Crysta’s comfort and spaciousness make it the ideal vehicle for long pilgrimage circuits, especially for senior citizens and children. Easy accessibility and smooth rides enhance the overall darshan experience."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Tour Coordination",
    "WhyChoosedescription": "Our dedicated team is available around-the-clock to help you book, modify, or plan your Ashtavinayak Darshan. From pickup in Pune to temple entry timing guidance, we support you every step of the way."
  }
]






















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta for Pune to Ashtavinayak Darshan?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or via our website for easy and quick booking."
    },
    {
        question: "What is the route covered in the Ashtavinayak Darshan from Pune?",
        answer: "The Ashtavinayak Darshan includes visits to the eight Ganesh temples located around Pune, including Siddhivinayak, Ballaleshwar, Varadavinayak, and others."
    },
    {
        question: "Is Innova Crysta comfortable for a full-day Ashtavinayak Darshan?",
        answer: "Yes, the Innova Crysta is spacious and comfortable, perfect for a full-day pilgrimage with family or friends."
    },
    {
        question: "Can I customize the Ashtavinayak Darshan itinerary?",
        answer: "Yes, you can customize your route and stops according to your preferences."
    },
    {
        question: "Are the vehicles sanitized before the trip?",
        answer: "Absolutely, all vehicles are thoroughly cleaned and sanitized before every journey."
    },
    {
        question: "Does the rental fare include driver charges and fuel?",
        answer: "Yes, the fare includes fuel, driver charges, tolls, and taxes."
    },
    {
        question: "Can the driver assist with local temple information and guidance?",
        answer: "Our drivers are knowledgeable and can help with local insights during your Darshan trip."
    },
    {
        question: "Are there options for one-way or round-trip bookings?",
        answer: "Yes, both one-way and round-trip packages are available."
    },
    {
        question: "Can I request meal or rest stops during the Darshan?",
        answer: "Yes, stops can be arranged as per your convenience."
    },
    {
        question: "What payment methods are accepted?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Prakash Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Ashtavinayak Darshan with the Innova Crysta was smooth and comfortable. The driver was very helpful throughout the trip.”',
    },
    {
        name: 'Ms. Deepa Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommended service for pilgrimage tours. The car was spacious, clean, and perfect for our family outing.”',
    },
];




































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneToAshtavinayakSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Ashtavinayak Darshan Innova Crysta Booking",
  "description": "Chauffeur-driven Innova Crysta for Ashtavinayak Darshan from Pune. Ideal for family and religious tours. AC cabs, comfortable seats, and online booking with reliable service.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Religious Pilgrimage Cab Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Ashtavinayak Temples"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-ashtavinayak-innova-crysta-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Ashtavinayak Darshan Innova Crysta Cab | Pilgrimage Taxi Booking</title>
  <meta
    name="description"
    content="Book Innova Crysta cab from Pune for Ashtavinayak Darshan. AC, chauffeur-driven, comfortable family travel for spiritual tours. Easy online booking and affordable rates."
  />
  <meta
    name="keywords"
    content="Pune to Ashtavinayak Innova Crysta Cab Booking, One Way Innova Crysta Pune Ashtavinayak, Round Trip Innova Crysta Pune Ashtavinayak, AC Innova Crysta Taxi Pune Ashtavinayak, Chauffeur Driven Innova Crysta Pune Ashtavinayak, Private Innova Crysta Taxi Pune Ashtavinayak, Online Booking Innova Crysta Pune Ashtavinayak, Ashtavinayak Pilgrimage Innova Crysta, Comfortable Innova Crysta Cab Pune Ashtavinayak, Budget Innova Crysta Taxi Pune Ashtavinayak, Religious Tour Innova Crysta Pune, Family Trip Innova Crysta Ashtavinayak, Reliable Innova Crysta Taxi Ashtavinayak, Long Distance Innova Crysta Taxi, Weekend Trip Innova Crysta Ashtavinayak"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToAshtavinayakSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/8.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoashtavinayakdarshaninnova;